module.exports = __webpack_public_path__ + "media/images/bank_images/banespa-093b8998ef4805d2ffa96df1d9467f2d.png";